import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { BreadcrumbService } from "../../../../_services/breadcrumb.service";
import { ClientsService } from "src/app/_services/clients.service";

@Component({
  selector: "app-client-ai-usage",
  templateUrl: "./client-ai-usage.component.html",
  styleUrls: ["./client-ai-usage.component.css"],
})
export class ClientAiUsageComponent implements OnInit {
  entityUuid: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private clientsService: ClientsService,
    private breadcrumbService: BreadcrumbService
  ) {}

  ngOnInit() {
    const numericId = this.route.snapshot.parent?.params?.id;
    this.clientsService.getClient(numericId).subscribe((data) => {
      this.entityUuid = data.result.uuid;
      this.breadcrumbService.changeBreadcrumbs(
        this.breadcrumbService.setForClient(data.result, "ai-usage")
      );
    });
  }
}
